module.exports = __webpack_public_path__ + "media/images/front/home/parallax-23917f6b02579852d085c39648047f48.jpg";